import * as DS from '@aurorasolar/ds';
import ms from 'ms';
import { useCallback } from 'react';

type ToastConfig = { timeout?: number };

export const useToast = () => {
  const { upsert, remove } = DS.useNotifications();

  const showError = useCallback(
    (title: string, description = '', action?: DS.IButton) =>
      upsert({
        config: { actions: action ? [action] : undefined, description, title, variant: 'error' },
        id: 'toast',
        type: 'toast',
      }),
    [upsert]
  );

  const showSuccess = useCallback(
    (title: string, description = '', { timeout = ms('30s') }: ToastConfig = {}) =>
      upsert({
        config: { description, timeout, title, variant: 'success' },
        id: 'toast',
        type: 'toast',
      }),
    [upsert]
  );

  const hideToast = useCallback(() => remove('toast'), [remove]);

  return { hideToast, showError, showSuccess };
};
